import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormControl, FormDescription, FormField, FormItem, FormLabel } from '../ui/form';
import { Switch } from '../ui/switch';

interface IFormSwitchProps {
  label?: string;
  description?: string;
  name: string;
  onCheckedChange?: (checked: boolean) => void;
}

const FormSwitch: React.FunctionComponent<IFormSwitchProps> = ({
  name,
  label,
  description,
  onCheckedChange,
}) => {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <div className='space-y-0.5'>
            {!!label && <FormLabel>{label}</FormLabel>}
            {!!description && <FormDescription>{description}</FormDescription>}
          </div>
          <FormControl>
            <Switch
              checked={field.value}
              onCheckedChange={(checked) => {
                field.onChange(checked);
                onCheckedChange?.(checked);
              }}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default FormSwitch;
